import React, { useEffect, useState } from "react";
import Button, {
  ButtonTypes,
  ButtonColorTypes,
} from "../../shared-components/Button";
import { uniqueUUID } from "../../utils";
import { PersonFormStateError } from "../PersonFormErrorState";

import PersonFormAddressField from "./PersonFormAddressFieldv2";
import XIcon from "../../shared-components/icons/XIcon";

export interface AddressesDefinitions {
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  key: string;
  completed?: string;
}

type Props = {
  onChange?: (aliases: AddressesDefinitions[]) => void;
  error?: PersonFormStateError;
  prefill?: AddressesDefinitions[];
  alternateColor?: boolean;
};

function buildEmptyDefinition(): AddressesDefinitions {
  return {
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    completed: "",
    key: uniqueUUID(),
  };
}
const PersonFormAddresses = ({
  onChange,
  error,
  prefill,
  alternateColor,
}: Props) => {
  const [fieldsList, setFields] = useState<AddressesDefinitions[]>([]);

  const appendFields = () => {
    handleChange([...fieldsList, buildEmptyDefinition()]);
  };

  const removeField = (idx: number) => {
    fieldsList.splice(idx, 1);
    handleChange([...fieldsList]);
  };

  const handleChange = (list: AddressesDefinitions[]) => {
    onChange?.(list);
    setFields(list);
  };

  useEffect(() => {
    if (prefill && prefill.length > 0) {
      handleChange([...prefill]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefill]);

  const handleAdd = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    appendFields();
  };

  const handleRemove = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    idx: number
  ) => {
    e.preventDefault();
    removeField(idx);
  };
  return (
    <div className="flex items-center">
      {fieldsList.length > 0 && (
        <div className="flex-1">
          {fieldsList.map((fields, idx) => (
            <div
              key={fields.key}
              className="flex flex-nowrap items-center mr-4 mb-2"
            >
              <PersonFormAddressField
                prefill={fields}
                onChange={(address) => {
                  fieldsList[idx] = address;
                  handleChange([...fieldsList]);
                }}
              />
              {idx >= 0 && (
                <span className="pl-2 h-0">
                  <div
                    className="rounded-full bg-gray-50 border p-1 text-gray-500 cursor-pointer"
                    onClick={(e) => handleRemove(e, idx)}
                  >
                    <XIcon />
                  </div>
                </span>
              )}
            </div>
          ))}
        </div>
      )}
      <div className="self-end pb-2">
        <Button
          type={ButtonTypes.add}
          text="Add Address"
          colorType={
            alternateColor
              ? ButtonColorTypes.alternate
              : ButtonColorTypes.action
          }
          className="w-44"
          onClick={handleAdd}
        />
      </div>
    </div>
  );
};

export default PersonFormAddresses;
